import React, { useState } from 'react'
import { useIntl } from 'react-intl'
import AbsenceEntriesProvider from 'contexts/absence-entries'
import { useLocationStateIntent } from 'hooks/location-intent'
import { useOptionedString } from 'hooks/optioned-string'
import ContextMenu from 'widgets/context-menu'
import { Plain } from 'components/button'
import { DownloadCloud } from 'styled-icons/feather'
import Modal from 'modals/dialog'
import Balance from './balance'
import Details from './details'
import Summary from './summary'

const ExportAbsence = ({ salt }) => {
    const { formatMessage } = useIntl()
    const optionizeString = useOptionedString()

    const [exporting, setExporting] = useState(null)

    useLocationStateIntent({
        intent: 'export-details',
        action: data => setExporting({
            ...data,
            type: 'details'
        })
    })

    useLocationStateIntent({
        intent: 'export-balance',
        action: data => setExporting({
            ...data,
            type: 'balance'
        })
    })

    useLocationStateIntent({
        intent: 'export-summary',
        action: data => setExporting({
            ...data,
            type: 'summary'
        })
    })

    salt = `${salt}:export`

    const exportActions = {
        details: () => ({
            salt: `${salt}:details`,
            label: formatMessage({
                id: 'absence_export_type_details',
                defaultMessage: 'Absence details'
            }),
            helptext: formatMessage({
                id: 'absence_export_type_details_helper',
                defaultMessage: 'Detailed report of registered absence'
            }),
            onClick: () => setExporting({ type: 'details' }),
            effect: 'neutral'
        }),
        balance: () => ({
            salt: `${salt}:balance`,
            label: formatMessage({
                id: 'absence_export_type_balance',
                defaultMessage: 'Absence balance'
            }),
            helptext: formatMessage({
                id: 'absence_export_type_balance_helper',
                defaultMessage: 'Balance per absence type per person'
            }),
            onClick: () => setExporting({ type: 'balance' }),
            effect: 'neutral'
        }),
        summary: () => ({
            salt: `${salt}:summary`,
            label: formatMessage({
                id: 'absence_export_type_summary',
                defaultMessage: 'Absence summary'
            }),
            helptext: formatMessage({
                id: 'absence_export_type_summary_helper',
                defaultMessage: 'Summary per absence type per person'
            }),
            onClick: () => setExporting({ type: 'summary' }),
            effect: 'neutral'
        })
    }

    const Interaction = {
        details: Details,
        balance: Balance,
        summary: Summary
    }[exporting?.type] ?? null

    const interactionProps = {
        ...exporting,
        salt: `${salt}:${exporting?.type}`
    }
    return (
        <>
            <ContextMenu
                salt={salt}
                actions={exportActions}
                trigger={(
                    <Plain
                        className="constructive"
                        icon={DownloadCloud}
                        disabled={exporting}>
                        {optionizeString(formatMessage({
                            id: 'action_export',
                            defaultMessage: 'Export'
                        }))}
                    </Plain>
                )} />
            <Modal
                show={!!exporting}
                dismiss={() => setExporting(null)}
                className="scrollable"
                salt={salt}>
                {!!Interaction && <Interaction {...interactionProps} />}
            </Modal>
        </>
    )
}

export default props => (
    <AbsenceEntriesProvider fetchOnMount={false}>
        <ExportAbsence {...props} />
    </AbsenceEntriesProvider>
)